import { render, staticRenderFns } from "./layout-global-menu.vue?vue&type=template&id=6aed7d02&scoped=true&"
import script from "./layout-global-menu.vue?vue&type=script&lang=js&"
export * from "./layout-global-menu.vue?vue&type=script&lang=js&"
import style0 from "./layout-global-menu.vue?vue&type=style&index=0&id=6aed7d02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aed7d02",
  null
  
)

export default component.exports